import HelpModules from 'modules/help';

const Help = () => {
  return (
    <HelpModules />
  )
};

export default Help;